

export enum LandingPageComponentType {
    SELL_TRADE_HERO = "sell-trade.sell-trade-hero",
    CARDS_SLIDER = "lp-components.cards-slider",
    BROWSE_CARS_BY = "sections.browse-cars-by",
    BULLETED_LIST = "shared.bulleted-list",
    FINANCING_CALCULATOR = "lp-components.financing-calculator",
    BANKS_GROUP = "sections.banks-group",

    // Car Prices
    LAYOUT_BREADCRUMB = "layout.breadcrumb",
    LP_CAR_PRICES_HERO = "lp-prices.prices-hero",
    LP_CAR_PRICES_CAR_PRICES_DETAILS_TABLE = "lp-prices.prices-details-table",
    LP_COMPONENTS_BROWSER_CARS_BY_PRICE_RANGE = "lp-components.browser-cars-by-price-rane",
    LP_CAR_PRICES_BROWSER_PRICES_MK_MDL_YR = "lp-prices.browse-prices-make-model-year",


    BULLETED_LIST_CARDS = "shared.bulleted-list-cards-new"
}


export interface ILandingContentSection {
    __component: LandingPageComponentType;
}
